import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DeductionSummaryReport } from './Pages/listing';

export const DeductionSummaryReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={DeductionSummaryReport} />
    </Fragment>
)